import { Immutable } from '@zervant/reactcomponents'
import { ConfigInterface } from 'client/Interfaces/ConfigsInterface'

import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = null

type StateType = ConfigInterface | null
type PayloadType = ConfigInterface

// eslint-disable-next-line no-underscore-dangle
function _getConfigs(state: StateType, payload: PayloadType): StateType {
  return Immutable.copy(payload)
}

const reducer = ReducerBuilder.create<StateType, PayloadType>(INITIAL_STATE)
  .mapAction('GET_CONFIGS', _getConfigs)
  .build()

export default reducer
